interface TridionErrorProps {
  url?: string;
}

const TridionError: React.FC<TridionErrorProps> = ({ url }) => (
  <iframe
    className="content-iframe h-[calc(100vh-var(--height-mobile-top-nav)-var(--height-searchbar-subheader))] w-full border-0 md:h-[calc(100vh-var(--height-searchbar-subheader))]"
    allow="fullscreen"
    src={url}
    title="Error content"
  />
);

export default TridionError;
